<template>
  <table class="definitionsTable">
    <thead>
      <tr>
        <th class="term">
          {{ "definitionsPage.term" | t }}
        </th>
        <th>{{ "definitionsPage.description" | t }}</th>
      </tr>
    </thead>
    <tbody v-if="showDefinitionsList">
      <tr v-for="definition in definitions" :key="definition.term">
        <!-- eslint-disable vue/no-v-html -->
        <td class="table-cell" v-html="definition.term" />
        <td class="table-cell" v-html="definition.definition" />
        <!-- eslint-enable vue/no-v-html -->
      </tr>
    </tbody>
    <tbody v-else>
      <NoResults :searchTerm="searchTerm" />
    </tbody>
  </table>
</template>

<script>
import NoResults from "@/components/definitions/NoResults";

export default {
  components: {
    NoResults,
  },
  props: ["definitions", "searchTerm", "showDefinitionsList"],
};
</script>

<style scoped lang="scss">
.definitionsTable {
  width: 100%;
  margin-top: 18px;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 19px;
  background-color: #fff;

  th {
    padding: 10px;
    border: 1px solid #dedede;
    font-weight: bold;
    text-align: left;
  }

  .term {
    width: 33%;
  }

  .table-cell {
    padding: 10px;
    border: 1px solid #dedede;
    font-size: 12px;
    text-align: left;
  }
}
</style>
